import React, {useCallback, useContext, useEffect} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import {useMenu} from '../../../hooks/useMenu';
import BodyContentView from '../../views/bodyContentView';
import CalibrationPB from './calibrationPB';
import ZeroComplete from './zero-complete';

function ZeroCalSave({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {onComponent, selected} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  const onRight = useCallback(() => {
    onComponent(<CalibrationPB />);
  }, []);

  useEffect(() => {
    if (!leftPress) return;

    onExit();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;
    onRight();
  }, [rightPress]);

  useEffect(() => {
    onUpdateCommands({onLeft: onExit, onRight});
  }, [onExit, onRight]);

  return (
    <BodyContentView
      title="Zero Calibration"
      left="Cancel"
      right="Yes"
      caption={
        <>
          <span>Prepare the meter:</span>
          <p>1. Allow the meter to warm up for at least 20 minutes after applying power.</p>
          <p>
            2. Run the process fluid through the sensor until the sensor temperature reaches the
            normal process operating temperature.
          </p>
          <p>
            3. Stop flow through the sensor by shutting the downstream valve, and then the upstream
            valve if available.
          </p>
          <p>
            4. Verify that the sensor is blocked in, that flow has stopped, and that the sensor is
            completely full of process fluid.
          </p>
          <p>Begin zero calibration?</p>
        </>
      }
    />
  );
}

export default ZeroCalSave;
